import React from "react";
import { useTranslation } from "react-i18next";

const SFLogo = () => {
  const { t } = useTranslation();
  return (
    <svg
      style={{ marginTop: "10px" }} 
      width="33"
      height="38"
      viewBox="0 0 33 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>{t("assets.skillsFroundry")}</title>
      <path d="M32.8271 0L0 11.9385L32.8271 6.13805V0Z" fill="#FFD500" />
      <path
        d="M5.35764 27.0235H11.6041V23.5364H5.35764V20.7461H12.1429L9.82027 16.9121H0V33.8212H13.9268V29.8107H5.35764V27.0235Z"
        fill="white"
      />
      <path
        d="M22.2172 16.9121L19.399 22.4896L16.5809 16.9121H10.9414L16.7543 27.0235V33.8212H21.8642V27.0235L27.8536 16.9121H22.2172Z"
        fill="white"
      />
    </svg>
  );
};

export default SFLogo;
